import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { toast } from 'sonner';
import { api } from '../lib/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await login(email, password);
      
      if (!response || !response.user) {
        throw new Error('Ungültige Antwort vom Server');
      }

      // Wenn Passwort geändert werden muss, leite zur Passwort-Änderung weiter
      if (response.user.mustChangePassword) {
        console.log('Muss Passwort ändern, leite weiter...');
        navigate('/change-password', { replace: true });
        toast.info('Bitte ändern Sie Ihr temporäres Passwort');
        return;
      }

      // Normale Navigation basierend auf der Rolle
      if (response.user.role === 'admin') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/leads', { replace: true });
      }
       
      toast.success('Erfolgreich eingeloggt');
    } catch (error) {
      console.error('Login-Fehler:', error);
      toast.error(error.message || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Bitte geben Sie Ihre E-Mail-Adresse ein');
      return;
    }

    setLoading(true);
    try {
      await api.forgotPassword(email);
      toast.success('Wenn ein Account mit dieser E-Mail existiert, erhalten Sie in Kürze eine E-Mail mit weiteren Anweisungen.');
      setShowForgotPassword(false);
    } catch (error) {
      console.error('Fehler beim Zurücksetzen des Passworts:', error);
      toast.error('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.');
    } finally {
      setLoading(false);
    }
  };

  if (showForgotPassword) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <Card className="w-[400px]">
          <CardHeader>
            <div className="flex flex-col items-center">
              <img src="/logo.webp" alt="Logo" className="w-32 mb-4" />
              <CardTitle className="text-2xl text-center">Passwort zurücksetzen</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleForgotPassword} className="space-y-4">
              <div className="space-y-2">
                <Input
                  type="email"
                  placeholder="E-Mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="space-y-2">
                <Button
                  type="submit"
                  className="w-full"
                  disabled={loading}
                >
                  {loading ? 'Wird gesendet...' : 'Passwort zurücksetzen'}
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  className="w-full"
                  onClick={() => setShowForgotPassword(false)}
                  disabled={loading}
                >
                  Zurück zum Login
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <Card className="w-[400px]">
        <CardHeader>
          <div className="flex flex-col items-center">
            <img src="/logo.webp" alt="Logo" className="w-32 mb-4" />
            <CardTitle className="text-2xl text-center">Login</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Input
                type="email"
                placeholder="E-Mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Input
                type="password"
                placeholder="Passwort"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Button
                type="button"
                variant="link"
                className="px-0 text-sm"
                onClick={() => setShowForgotPassword(true)}
              >
                Passwort vergessen?
              </Button>
            </div>
            <Button
              type="submit"
              className="w-full"
              disabled={loading}
            >
              {loading ? 'Lädt...' : 'Einloggen'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
} 